import {runElectronFunc} from "./comm";
import {n2v} from '../Often';

const logout = (props) => {
    const { REmDIRECT_URI } = props;
    if(window._IsMini){
        location.replace(Often.null2Void(REmDIRECT_URI, (window._ENTER_YN === "Y" ? '/entMiniSignIn.act?logout=Y' : '/miniSignIn.act')))
    }
    runElectronFunc('ElectronUserApi' , 'logout');
    ElectronApi.Window.setMenuVisibleValue({
        logoutMenuVisible: false,
        lockMenuVisible: false,
        windowModeVisible: false,
    })
}

const getWhoAmI = () => n2v(runElectronFunc("ElectronUserApi", "getWhoAmI"), "");

const getMediaAccessStatus = () => runElectronFunc("ElectronUserApi", "getMediaAccessStatus");
const askForMediaAccess = () => runElectronFunc("ElectronUserApi", "askForMediaAccess");
const openSystemPreferences = () => runElectronFunc("ElectronUserApi", "openSystemPreferences");

/**
 * ENTER: 하이투자증권에서 사용. (isHiib)
 */
const getUserIdWithNLogin = () => {
    try {
        let filepath = "C:\\ProgramData\\log\\n5login_" + dayjs(Date.now()).format("YYYYMMDD") + ".log";
        let encoding = "binary";
        return Often.null2Void(runElectronFunc("ElectronUserApi", "getUserIdWithNLogin", {filepath, encoding}), "");
    } catch (e) {
        Often.toast('error', i18next.t('front.alert.errorTryAgain'));
    }
}

export {
    logout,
    getWhoAmI,
    getMediaAccessStatus,
    askForMediaAccess,
    openSystemPreferences,
    getUserIdWithNLogin
};